export const FILE_NAME = {
  SKILLPATHS_CERTIFICATE: "{skillpath}-certificate.pdf"
};